import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { SvgRepo } from 'src/app/repositories/svg-repo';
import { DataAfterCloseDeleteSynopticModal } from './model/dataAfterCloseDeleteSynopticModal';

@Component({
    selector: 'app-modal-delete-svg',
    templateUrl: './modal-delete-svg.component.html',
    styleUrls: ['./modal-delete-svg.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteSvgComponent implements OnDestroy {

  loading = false;
  Uidsvg: string;
  deleteSuccess: any;
  deleteError: any;

  dataAfterClose: DataAfterCloseDeleteSynopticModal;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private router: Router,
    private svgRepo: SvgRepo,
    private logger: NGXLogger
  ) {
    this.dataAfterClose = new DataAfterCloseDeleteSynopticModal();
  }

  deleteSvg() {
    this.loading = true;
    this.svgRepo.deleteSvg(this.data.stationUid, this.data.synopticUid).toPromise()
      .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('Le synoptique a bien été supprimé');
          this.dataAfterClose.successDelete = true;
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('svg.delete.error');
          this.dataAfterClose.successDelete = false;
        });
  }

  ngOnDestroy() {
  }

  onCancel() {
    this.dataAfterClose.successDelete = false;
  }
}
